module.exports = __webpack_public_path__ + "img/03-txt-info.59c31750.png";